// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IsoCertificate_wrapper__t0FiP"};